/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { AppointmentRequestVariantId } from './AppointmentRequestVariantId';
import {
    AppointmentRequestVariantIdFromJSON,
    AppointmentRequestVariantIdFromJSONTyped,
    AppointmentRequestVariantIdToJSON,
    AppointmentRequestVariantIdToJSONTyped,
} from './AppointmentRequestVariantId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PostBalanceTransactionRequest
 */
export interface PostBalanceTransactionRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PostBalanceTransactionRequest
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PostBalanceTransactionRequest
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof PostBalanceTransactionRequest
     */
    currencyDate: Date;
    /**
     * 
     * @type {number}
     * @memberof PostBalanceTransactionRequest
     */
    creditAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PostBalanceTransactionRequest
     */
    debitAmount: number;
    /**
     * 
     * @type {string}
     * @memberof PostBalanceTransactionRequest
     */
    currency: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostBalanceTransactionRequest
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostBalanceTransactionRequest
     */
    transactionCode: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof PostBalanceTransactionRequest
     */
    classId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {AppointmentRequestVariantId}
     * @memberof PostBalanceTransactionRequest
     */
    appointmentBookingId: AppointmentRequestVariantId | null;
    /**
     * 
     * @type {boolean}
     * @memberof PostBalanceTransactionRequest
     */
    includeTax?: boolean;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof PostBalanceTransactionRequest
     */
    locationId?: ActorActivityRecordActorUserId | null;
}

/**
 * Check if a given object implements the PostBalanceTransactionRequest interface.
 */
export function instanceOfPostBalanceTransactionRequest(value: object): value is PostBalanceTransactionRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('currencyDate' in value) || value['currencyDate'] === undefined) return false;
    if (!('creditAmount' in value) || value['creditAmount'] === undefined) return false;
    if (!('debitAmount' in value) || value['debitAmount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('transactionCode' in value) || value['transactionCode'] === undefined) return false;
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('appointmentBookingId' in value) || value['appointmentBookingId'] === undefined) return false;
    return true;
}

export function PostBalanceTransactionRequestFromJSON(json: any): PostBalanceTransactionRequest {
    return PostBalanceTransactionRequestFromJSONTyped(json, false);
}

export function PostBalanceTransactionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostBalanceTransactionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'currencyDate': (new Date(json['currencyDate'])),
        'creditAmount': json['creditAmount'],
        'debitAmount': json['debitAmount'],
        'currency': json['currency'],
        'description': json['description'],
        'transactionCode': json['transactionCode'],
        'classId': ActorActivityRecordActorUserIdFromJSON(json['classId']),
        'appointmentBookingId': AppointmentRequestVariantIdFromJSON(json['appointmentBookingId']),
        'includeTax': json['includeTax'] == null ? undefined : json['includeTax'],
        'locationId': json['locationId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['locationId']),
    };
}

export function PostBalanceTransactionRequestToJSON(json: any): PostBalanceTransactionRequest {
    return PostBalanceTransactionRequestToJSONTyped(json, false);
}

export function PostBalanceTransactionRequestToJSONTyped(value?: PostBalanceTransactionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'currencyDate': value['currencyDate'].toISOString().substring(0,10),
        'creditAmount': value['creditAmount'],
        'debitAmount': value['debitAmount'],
        'currency': value['currency'],
        'description': value['description'],
        'transactionCode': value['transactionCode'],
        'classId': ActorActivityRecordActorUserIdToJSON(value['classId']),
        'appointmentBookingId': AppointmentRequestVariantIdToJSON(value['appointmentBookingId']),
        'includeTax': value['includeTax'],
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
    };
}

